import React from "react";
import { Hit, HitSourceOrder, HitSourceProduct } from "@/types/search";

import {formatDateFromStringWithHour} from "@/utils/formatDate";
import ImageWithLoader from "@/components/UiElements/ImageWithLoader";
import useRouter from "@/utils/Router";
export type SearchProps = {
    item: Hit;
    close: () => void;
};

const NavbarSearchHit: React.FC<SearchProps> = ({ item, close }) => {

    if (item._index === "product_v_2" && isHitSourceProduct(item._source)) {
        return <div><ProductSearchItem item={item._source} close={close} /></div>;
    }

    if (item._index === "order_v_1" && isHitSourceOrder(item._source)) {
        return <div><OrderSearchItem item={item._source} close={close} /></div>;
    }

    return <>null</>;
};

export default NavbarSearchHit;

// ProductSearchItem Component
const ProductSearchItem: React.FC<{ item: HitSourceProduct, close:()=>void }> = ({ item, close }) => {

    const router = useRouter();
    return (
        <div
            className={"flex flex-row gap-xs hover:bg-gray-100 transition-all cursor-pointer py-sm group rounded-md my-xs"}
            onClick={() => {
                if (!item.bundle) {
                    router.push(`/products/bundle/${item["sku"]}`)
                } else {
                    router.push(`/products/sku/${item["sku"]}`)
                }
                close();
            }}
        >
            <div className={"flex flex-col  flex-grow"}>
                <div className={"flex flex-row gap-md item-center"}>
                    <div className="font-icon-solid text-title-md w-[18px] ml-md text-center text-primary-600">
                        {!item?.bundle ? "" : ""}
                    </div>
                    <p className={"text-title-md pl-sm"}>{item.name}</p>
                </div>
                <div className={"flex flex-row gap-xs ml-[50px] pt-sm"}>
                    <Label text={`SKU: ${item.sku}`}/>
                    <Label text={`${item.variant_name}`}/>
                    {
                        item.pricing &&
                        <Label text={`${item.pricing.price}$`}/>
                    }
                </div>
            </div>
            <div className={" flex flex-row justify-center items-center pr-sm"}>
                <ImageWithLoader
                    src={item.two_d_image_url}
                    className={"w-[40px] h-[40px]"}
                    alt={item.name}
                />
            </div>
        </div>
    )
};

// OrderSearchItem Component
const OrderSearchItem: React.FC<{ item: HitSourceOrder, close:()=>void }> = ({ item, close }) => {
    const router = useRouter();
    return (
        <div
            className={"flex flex-row gap-xs hover:bg-gray-100 transition-all cursor-pointer py-sm group rounded-md my-xs"}
            onClick={() => {
                router.push(`/order/${item.id}`)
                close();
            }}
        >
            <div className={"flex flex-col  flex-grow"}>
                <div className={"flex flex-row gap-md item-center"}>
                    <div className="font-icon-solid text-title-md  w-[18px] ml-md text-center text-primary-600"></div>
                    <p className={"text-title-md pl-sm "}>#{item.external_order_number}</p>

                </div>
                <div className={"flex flex-row gap-xs ml-[50px] pt-sm"}>
                    <Label text={`Order ${item.order_status}`}/>
                    <Label text={`Job ${item.lumialase_job_call_status}`}/>
                </div>
                <span className={"flex flex-row gap-xs ml-[50px] text-[13px] text-gray-400  pl-sm pt-xs"}>
                Ordered at: {formatDateFromStringWithHour(item.order_date)}
                    <span className="font-icon-light text-gray-300 select-none"></span>
                Created at: {formatDateFromStringWithHour(item.created_at)}


            </span>
            </div>
        </div>
    );
}

// Type Guards
function isHitSourceProduct(source: any): source is HitSourceProduct {
    return "sku" in source; // Adjust based on `HitSourceProduct` structure
}

function isHitSourceOrder(source: any): source is HitSourceOrder {
    return "external_order_number" in source; // Adjust based on `HitSourceOrder` structure
}


const Label: React.FC<{ text:string }> = ({ text }) => {
    return (
        <span className={"text-[12px] bg-gray-100 rounded-sm px-sm py-xs inline-flex justify-center items-center capitalize group-hover:bg-gray-200 transition-all"}>
            {text.replace(/_/g, ' ')}
        </span>
    );
};

export {Label};